// Single-tenant build: the API target is fixed via VITE_APP_BASE_URL and the
// tenant is resolved server-side (one Company per node). No subdomain rewriting
// or X-Tenant header is used anymore.

const getTenantBaseUrl = () => import.meta.env.VITE_APP_BASE_URL || "";

// No per-firm subdomain in single-tenant mode.
const getTenantSubdomain = () => "";

// Each node is a single billed firm (not the shared "app" portal), so billing
// and seat-based user management behave normally.
const isAppTenantSubdomain = () => false;

export { getTenantBaseUrl, getTenantSubdomain, isAppTenantSubdomain };
